/**
 * @flow
 * @relayHash b48551382d5f2299e18b41951c2d747b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type fetchCertificateTemplateQueryVariables = {|
  certificateId?: ?string
|};
export type fetchCertificateTemplateQueryResponse = {|
  +certificate: ?{|
    +name: ?string,
    +templateInfo: ?{|
      +template: ?string
    |},
  |}
|};
*/


/*
query fetchCertificateTemplateQuery(
  $certificateId: String
) {
  certificate(id: $certificateId) {
    name
    templateInfo {
      template
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "certificateId",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "certificateId",
    "type": "String"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "templateInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "CertificateTemplateInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "template",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "fetchCertificateTemplateQuery",
  "id": null,
  "text": "query fetchCertificateTemplateQuery(\n  $certificateId: String\n) {\n  certificate(id: $certificateId) {\n    name\n    templateInfo {\n      template\n    }\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "fetchCertificateTemplateQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "certificate",
        "storageKey": null,
        "args": v1,
        "concreteType": "Certificate",
        "plural": false,
        "selections": [
          v2,
          v3
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "fetchCertificateTemplateQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "certificate",
        "storageKey": null,
        "args": v1,
        "concreteType": "Certificate",
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '28ea1af6329658cc7a0b1ca79856914b';
module.exports = node;
